import { Grid } from '@material-ui/core'
import React from 'react'
import ContainedButton from '../../../../components/Actions/ContainedButton'
import InputForm from '../../../../components/Forms/InputForm'
import SelectForm from '../../../../components/Forms/SelectForm'
import SimpleCard from '../../../../components/Structure/Cards/SimpleCard'
import DisplayText from '../../../../components/Texts/DisplayText'

const ContactInfo = ({content, form, onChange, sending, onSubmit}) => {

    return(
        <SimpleCard>
            <Grid container spacing={4} justify='flex-end'>
                <Grid item xs={12}>
                    <DisplayText variant='subtitle1'>{content.contact_info}</DisplayText>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <InputForm data={form.email} onChange={onChange} />
                        </Grid>
                        <Grid item sm={4} xs={12} >
                            <SelectForm data={form.mobile_country_id} onChange={onChange} />
                        </Grid>
                        <Grid item sm={8} xs={12} >
                            <InputForm data={form.mobile} onChange={onChange} />
                        </Grid>
                        <Grid item sm={4} xs={12} >
                            <SelectForm data={form.fixed_phone_country_id} onChange={onChange} />
                        </Grid>
                        <Grid item sm={8} xs={12} >
                            <InputForm data={form.fixed_phone} onChange={onChange} />
                        </Grid>    
                        <Grid item md={6} xs={12} >
                            <InputForm data={form.zip} onChange={onChange} />
                        </Grid>
                        <Grid item md={6} xs={12} >
                            <InputForm data={form.city} onChange={onChange} />
                        </Grid>                             
                    </Grid>
                </Grid>
                <Grid item>
                    <ContainedButton color='primary' loading={sending} onClick={onSubmit}>{content.button}</ContainedButton>
                </Grid>
            </Grid>
        </SimpleCard>
    )
}

export default ContactInfo